'use client';

//import {redirect} from 'next/navigation';

export default function NotFoundPage() {
    return <>
        <h1> Not Found </h1>
        <p> The page you&rsquo;re looking for doesn&rsquo;t exist. </p>
    </>;
}
